<template>

    <v-page-body>

        <v-page-section padded>

            <template #title>{{ integration.name }}</template>

            <template #body>

                <transition name="modal">
                    <v-modal-integration-delete v-if="showModal === 'delete'" :id="projectIntegration.id" />
                </transition>

                <v-notice>
                    <template #body>
                        <v-icon class="mb-15" :symbol="'action-' + integration.slug" :size="80" :radius="5" />
                        <p>{{ integration.description }}</p>
                    </template>
                    <template #footer>
                        <v-button v-if="!projectIntegration" @click.native="connect">Connect Integration</v-button>
                        <v-form v-if="projectIntegration">
                            <template #body>
                                <v-form-group dir="ver" label="Account Name">
                                    <v-input :model="projectIntegration.account_name" readonly />
                                </v-form-group>
                            </template>
                            <template #footer>
                                <v-button size="sm" btn-style="white-danger" @click.native="$store.commit('showModal', 'delete')">Remove</v-button>
                                <v-button size="sm" :loading="loading" @click.native="connect">Reconnect Integration</v-button>
                            </template>
                        </v-form>
                    </template>
                </v-notice>

            </template>

        </v-page-section>

    </v-page-body>

</template>

<script>

import IntegrationApi from '@api/IntegrationApi';
import ModalIntegrationDelete from '@modals/misc/ModalIntegrationDelete';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal-integration-delete': ModalIntegrationDelete,
    },

    props: {
        service: {
            type: String,
        },
    },

    data() {
        return {
            loading: false,
            integration: null,
            projectIntegration: null,
        }
    },

    computed: {

        slug() {
            return this.service || this.$route.params.slug;
        },

    },

    mounted() {
        this.getIntegration();
    },

    methods: {

        getIntegration() {
            this.$store.commit('loading', true);
            IntegrationApi.getIntegration(this.slug)
                .then((response) => {
                    this.integration = response.data.data;
                    if (this.$route.query.code) {
                        this.callbackHandler();
                    } else {
                        this.getProjectIntegration();
                    }
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        getProjectIntegration() {
            ProjectApi.getIntegration(this.project.id, this.slug)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.projectIntegration = response.data.data;
                    this.params = this.projectIntegration;
                    this.$events.$emit('pageLoaded');
                })
                .catch(() => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageLoaded');
                });
        },

        connect() {
            window.open(this.integration.authorize_url, '_parent');
        },

        callbackHandler() {
            ProjectApi.createIntegration(this.project.id, this.slug, this.$route.query)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertSuccess', this.$t('message.connected'));
                    this.projectIntegration = response.data.data;
                    this.$events.$emit('pageLoaded');
                })
                .catch((error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                    this.$events.$emit('pageLoaded');
                });
        },

    },

}

</script>